import React from "react";
import { FormControl, TextField } from "@mui/material";

const SearchBar = ({ value, setValue }) => {
    return (
        <React.Fragment>
            <FormControl variant="filled" fullWidth style={{ marginTop: -2 }} >
                <TextField
                    // className="me-2 mx-2"
                    size="small"
                    value={value}
                    inputProps={{ style: { height: 15, borderRadius: 10, width: 200 } }}
                    placeholder="Search"
                    variant="outlined"
                    onChange={(e) => setValue(e.target.value)}
                    InputProps={{
                        sx: { borderRadius: 15, backgroundColor: 'white' }
                    }}
                />
            </FormControl>

        </React.Fragment>
    );
};

export default SearchBar;
